import { PixelCrop } from 'react-image-crop';
import { canvasPreview } from './canvasPreview';

const toBlob = (canvas: HTMLCanvasElement): Promise<Blob> => {
  return new Promise((resolve) => {
    canvas.toBlob((blob) => {
      if (!blob) return;

      const imgFile = new File([blob], 'creative_image.png', { type: 'image/png' });
      resolve(imgFile);
    });
  });
};

export const imgPreview = async (image: HTMLImageElement | null, crop: PixelCrop, scale = 1, rotate = 0) => {
  if (!image || !crop) return;

  const canvas = document.createElement('canvas');

  canvasPreview(image, canvas, crop, scale, rotate);

  return await toBlob(canvas);
};
